"use client";

import { Grid2x2, List } from "lucide-react";
import React from "react";
import { useRouter, useSearchParams, usePathname } from "next/navigation";
import { getValidTab, ITabConfig } from "@/utils/getValidTabs";

export type PackageViewType = "list" | "grid";

export const PackageViewTypeTabs: ITabConfig<PackageViewType>[] = [
  {
    id: "grid",
    label: "Grid",
    icon: Grid2x2,
  },
  {
    id: "list",
    label: "List",
    icon: List,
  },
];

const PackageView: React.FC = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const viewTypeParams = searchParams.get("view");
  const viewType = getValidTab(
    viewTypeParams,
    PackageViewTypeTabs,
    PackageViewTypeTabs[0]?.id
  );

  // Helper to update URL params
  const updateSearchParams = (params: { view?: string }) => {
    const newParams = new URLSearchParams(searchParams.toString());

    if (params.view !== undefined) {
      newParams.set("view", params.view);
    }

    const newUrl = `${pathname}?${newParams.toString()}`;
    router.push(newUrl, { scroll: false });
  };

  return (
    <div className="hidden md:flex items-center divide-x divide-text-500 border border-text-500 rounded-[12px] overflow-hidden">
      {PackageViewTypeTabs.map((item) => (
        <button
          key={item.id}
          onClick={(e) => {
            e.preventDefault();
            updateSearchParams({ view: item.id });
          }}
          className={`p-2 ${viewType === item.id ? "bg-yellow-500" : ""}`}
        >
          {item.icon && (
            <item.icon
              className={`shrink-0 ${
                viewType === item.id
                  ? "text-white bg-yellow-500"
                  : "text-grey-400"
              }`}
              size={18}
            />
          )}
        </button>
      ))}
    </div>
  );
};

export default PackageView;
